"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikCheckSet = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var FormikCheckSet = function (props) {
    return (react_1.default.createElement(formik_1.FastField, { name: props.name }, function (_a) {
        var field = _a.field, form = _a.form;
        return (react_1.default.createElement(morse_react_1.CheckSetSelect, __assign({}, props, field, { multiple: true, onChange: function (value, options) {
                var _a, _b;
                field.setFieldValue((_a = props.name) !== null && _a !== void 0 ? _a : '', value);
                (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, value, options);
            } })));
    }));
};
exports.FormikCheckSet = FormikCheckSet;
//# sourceMappingURL=FormikCheckSet.js.map